import { api } from '@smena/ui';

export interface StaffUser {
  id: string;
  accountId: string;
  email: string;
  name: string;
  role: 'owner' | 'operator';
}

export async function fetchMe(): Promise<StaffUser> {
  const r = await api<{ user: StaffUser }>('/api/staff/auth/me');
  return r.user;
}

export async function login(input: { email: string; password: string }): Promise<StaffUser> {
  const r = await api<{ user: StaffUser }>('/api/staff/auth/login', {
    method: 'POST',
    json: input,
  });
  return r.user;
}

export async function logout(): Promise<void> {
  await api('/api/staff/auth/logout', { method: 'POST' });
}
